import { Renderer } from '@unseenco/taxi'
import { isDEVMODE, viewStorage } from '../_globals'

export default class Single extends Renderer {
  initialLoad() {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('load', () => this.onEnter());
    })
  }

  onEnter() {
    this.DOM = {}
  }

  onLeaveCompleted() {
  }
}
